run.$inject = [ 'MenuConstant', 'comite' ]

export default function run (MenuConstant, comite) {
	MenuConstant[0]['menu'].push(comite)
}


// WEBPACK FOOTER //
// ./src/app/u-faculty/generalSettings/generalSettings.run.js